import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactCompareImage from 'react-compare-image';
import { install } from 'resize-observer';
import { Row, Column, Container } from '@pella/sash-framework';
import { CTA } from '../../../../components';

import styles from './index.module.scss';

function BeforeAfterSlider(props) {
	const [position, setPosition] = useState(0.5);
	const { image_pairs, numbered_content, ctas } = props.data;

	if (!props.data) return null;

	if (typeof window !== 'undefined' && !window.ResizeObserver) {
		install();
	}

	return (
		<Container
			width={1800}
			className={styles.beforeAfter}
		>
			{props.data && image_pairs?.[0] && (
				<ReactCompareImage
					leftImage={image_pairs[0].image.url + '?format=pjpg&auto=webp'}
					leftAlt={image_pairs[0].image_alt}
					leftImageLabel={position > 0.25 ? 'Before' : ' '}
					rightImage={image_pairs[1].image.url + '?format=pjpg&auto=webp'}
					rightAlt={image_pairs[1].image_alt}
					rightImageLabel={position < 0.75 ? 'After' : ' '}
					sliderLineWidth={4}
					handleSize={50}
					onSliderPositionChange={(position) => setPosition(position)}
				/>
			)}

			{
				// Data from FNO Overview
				numbered_content?.[0] && (
					<Row className={styles.beforeAfter_Row}>
						{numbered_content.map((thumbs, index) => (
							<Column
								xs={12}
								md={4}
								key={index}
								className={styles.BeforeAfter_Col}
							>
								{thumbs.heading && <h3 className={styles.beforeAfter_Heading}>{thumbs.heading}</h3>}
								{thumbs.description && (
									<div
										className={styles.beforeAfter_Content}
										dangerouslySetInnerHTML={{
											__html: thumbs.description,
										}}
									/>
								)}
							</Column>
						))}
					</Row>
				)
			}

			{
				// Data from Channel Modular
				props.data.steps?.[0] && (
					<Row className={styles.beforeAfter_Row}>
						{props.data.steps.map((step, index) => (
							<Column
								xs={12}
								md={4}
								key={index}
								className={styles.BeforeAfter_Col}
							>
								<div
									className={`${styles.beforeAfter_Content} ${styles.beforeAfter_Content_channel}`}
									dangerouslySetInnerHTML={{ __html: step }}
								/>
							</Column>
						))}
					</Row>
				)
			}

			{ctas?.[0] && (
				<div className={styles.beforeAfter_ButtonWrapper}>
					<CTA
						data={ctas[0]}
						className={styles.beforeAfter_Button}
					/>
				</div>
			)}
		</Container>
	);
}

BeforeAfterSlider.propTypes = {
	data: PropTypes.object,
};

export default BeforeAfterSlider;
